import * as React from "react";
import {ShoppingBasket} from "../../models/ShoppingBasket";
import {ShoppingBasketLineItem } from "../../models/ShoppingBasketLineItem";

import {CartLineItem} from "./CartLineItem";
import {CartViewerTotals} from "./CartViewerTotals";

export interface CartViewerLineItemsProp
{
	shoppingBasket: ShoppingBasket;
	removeLineItem: (lineItem: ShoppingBasketLineItem) => void;
	adjustLineItemQty: (lineItem: ShoppingBasketLineItem, qty: number) => void;
	allowLineItemEdits: boolean;
}


export class CartViewerLineItems extends React.Component<CartViewerLineItemsProp, any>
{
	render()
	{
		const lineItems = this.getLineItems();

		return <div className="line-item-container">
		       {lineItems}
		       </div>;
	}

	private getLineItems()
	{
		const lineItems = this.props.shoppingBasket.lineItems;
		return lineItems.map((lineItem) =>
		{
			return <CartLineItem
					   key={lineItem.sku}
					   customer={this.props.shoppingBasket.customer}
					   lineItem={lineItem}
					   removeLineItem={this.props.removeLineItem}
					   adjustLineItemQty={this.props.adjustLineItemQty}
					   allowLineItemEdits={this.props.allowLineItemEdits}/>;
		});
	}
}


// WEBPACK FOOTER //
// ./src/components/shoppingbasket/CartViewerLineItems.tsx